import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=3d86da3a&scoped=true&"
import script from "./addressBook.vue?vue&type=script&lang=js&"
export * from "./addressBook.vue?vue&type=script&lang=js&"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=3d86da3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86da3a",
  null
  
)

export default component.exports